import React from 'react'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { ParagraphComp } from '../../../Components/ParagraphComp/ParagraphComp';
import { ImageComp } from '../../../Components/ImageCompo/ImageComp';
import { Col, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
const Redirection = () => {
    const navigate = useNavigate()
    const redirectionData = [
        {
            img: 'initial_reg.png',
            name: 'Initial Registration'
        },
        {
            img: 'action_key.png',
            name: 'Discover Registration details'
        },
        {
            img: 'handshake.png',
            name: 'Engage Details'
        },
        {
            img: 'interests.png',
            name: 'Expression of Interest'
        },
        {
            img: 'account_balance.png',
            name: 'Payment Details'
        },
        {
            img: 'license.png',
            name: 'Statutory Information & Documentation'
        },
        {
            img: '1.png',
            name: 'Level 1'
        },
        {
            img: '2.png',
            name: 'Level 2'
        },
        {
            img: 'activityAndProgramme.png',
            name: 'Activities & Programme'
        },
    ]

    const redirectPage = (componentName) => {
        navigate("/registration", { state: { tab: componentName } })
    }
    return (
        <>
            <div className='px-[40px] py-[20px]'>
                <div className='flex flex-wrap w-[100%] '>
                    <Row className='' >

                        {redirectionData.map(ele =>
                            <Col lg={4}  >
                                <div onClick={() => redirectPage(ele?.name)} className='w-[470px] cursor-pointer rounded-2xl mt-[20px] shadow-md flex flex-col gap-[10px] p-[20px] '>
                                    <div className='flex justify-between'>
                                        <div>
                                            <ImageComp className='object-cover h-[40px]' source={`./Images/${ele?.img}`} />
                                        </div>
                                        <div className='flex items-center align-middle justify-center bg-[#004878] rounded-full h-[40px] w-[40px]'>
                                            <ArrowForwardIosIcon className='text-white' />
                                        </div>
                                    </div>
                                    <div >
                                        <ParagraphComp className='text-2xl text-black tracking-wide ' text={ele?.name} />
                                    </div>
                                </div>
                            </Col>
                        )}
                    </Row>

                </div>

            </div>
        </>
    )
}

export default Redirection